import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { TooltipRenderProps } from 'react-joyride';

export default function JoyrideTooltip({
    backProps,
    closeProps,
    primaryProps,
    skipProps,
    tooltipProps,
    step,
    index,
    size,
    isLastStep,
}: TooltipRenderProps) {
    return (
        <Card {...tooltipProps} className="w-[360px] shadow-lg border-0">
            <CardHeader className="pb-2 pr-10 relative">
                {step.title && <CardTitle className="text-base">{step.title}</CardTitle>}
            </CardHeader>

            <CardContent className="text-base text-muted-foreground pt-0">
                {step.content}
            </CardContent>

            <CardFooter className="flex items-center justify-between pt-2">
                <span className="text-xs text-muted-foreground">
                    {index + 1} / {size}
                    <Button {...skipProps} variant="outline" size="sm" className={'ml-2'}>
                        Skip
                    </Button>
                </span>
                <div className="flex gap-2">
                    {index > 0 && (
                        <Button {...backProps} variant="outline" size="sm">
                            Back
                        </Button>
                    )}
                    <Button {...primaryProps} size="sm">
                        {isLastStep ? 'Ready to go' : 'Next'}
                    </Button>
                </div>
            </CardFooter>
        </Card>
    );
}
